import { shiftPeriod, type Period } from '@pfo/shared';

import { periodLabel } from '../model/homeLabels.js';
import styles from './MonthSwitcher.module.css';

/**
 * ‹ Tháng này › — the period every figure on the screen belongs to.
 *
 * Forward stops at the month the household is living in. There is nothing to report about
 * next month, and without the stop the arrow would page into an empty future forever.
 */
export function MonthSwitcher({
  period,
  current,
  onChange,
}: {
  period: Period;
  current: Period;
  onChange: (period: Period) => void;
}) {
  const atCurrent = period.year === current.year && period.month === current.month;

  return (
    <div className={styles.switcher}>
      <button
        type="button"
        className={styles.arrow}
        aria-label="Tháng trước"
        onClick={() => onChange(shiftPeriod(period, -1))}
      >
        ‹
      </button>
      <p className={styles.label} aria-live="polite">
        <span aria-hidden="true">🗓 </span>
        {periodLabel(period, current)}
      </p>
      <button
        type="button"
        className={styles.arrow}
        aria-label="Tháng sau"
        disabled={atCurrent}
        onClick={() => onChange(shiftPeriod(period, 1))}
      >
        ›
      </button>
    </div>
  );
}
